





































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Popup } from '@questelservices/common-vue';
import { Prop, Watch } from 'vue-property-decorator';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxToolbarItem } from 'devextreme-vue/popup';
 import _ from 'lodash';
 import { DxTagBox, DxTextBox } from 'devextreme-vue';
import { RespondEnum } from '@/models/comments/RespondEnum';
import { TextTemplateService } from '@/service/TextTemplateService';
import { CommentAutoTextData, CommentAutoTextEnum, EmailDetail } from '@/models/comments/CommentAutoText';
import { EmailResponseDto } from '@/models/comments/EmailResponseDto';
import HtmlEditor from "devextreme/ui/html_editor";
import { CommentService } from '../../service/CommentService';
import { confirm, alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import DateTime from '../../utilities/DateTime';
import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";

const moment = require('moment');
@Component({
  components: {
    Popup,
    DxHtmlEditor, DxItem, DxToolbar,
    DxToolbarItem,
    DxTagBox,
    DxTextBox,
    DxValidationGroup
  }
})
export default class RespondToComment extends Vue {
    private readonly emailSeparator: string = ';';
    $refs: Vue['$refs'] & {
        emailBodyEditor?: HtmlEditor;
        validationGroupRef? : ValidationGroup;
    } = {};

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }

    @Prop()
    EmailSubject!: string;

    @Prop()
    EmailFrom!: string;

    @Prop()
    EmailTo!: string;

    @Prop()
    selectedForwardToClientId!: Guid

    @Prop()
    selectedReplyToAgentId!: Guid

    @Prop()
    respondType!: RespondEnum;

    @Prop()
    commentData!: CommentAutoTextData;

    @Prop()
    commentEmail! : EmailDetail;


    @Prop({ default: false })
    showRespondEmail!: boolean;

    @Watch('commentEmail', {deep: true}) 
    onEmailCcChanged(newVal: any, oldVal: any) {
        if(newVal.Cc) {
            let cc = newVal.Cc.split(this.emailSeparator);
            this.emailCCSource = cc;
            this.selectedEmailCC = cc;
        }
        else {
            this.emailCCSource = [];
            this.selectedEmailCC = [];
        }

        if(newVal.Bcc) {
            let bcc = newVal.Bcc.split(this.emailSeparator);
            this.emailBccSource = bcc;
            this.selectedEmailBcc = bcc;
        }
        else {
            this.emailBccSource = [];
            this.selectedEmailBcc = [];
        }
    }

    get emailBodyValue() : string {
        return '';
    }

    get showingNotes() {
      return this.showRespondEmail;
    }

    set showingNotes(value) {
        this.$emit("hiding");
    }

    get emailSubject() : string {
        return this.EmailSubject;
    }

    get title() {
      switch (this.respondType) {
        case RespondEnum.ToAgent:
          return 'Respond to Agent';
        case RespondEnum.ToClient:
          return 'Forward to Client';
        default:
          return 'New Email';
      }
    }

    get emailToSource() : string[] {
        var result = this.EmailTo ? this.EmailTo.split(this.emailSeparator) : [];
        this.selectedToEmail = result;
        return result;
    }

    get bodyHtmlEditor() {
        return (this.$refs.emailBodyEditor as any).instance;
    }

    @Watch('respondType')
    async onRespondTypeChanged(newVal: RespondEnum, oldVal : RespondEnum) {
        if(newVal == RespondEnum.ToAgent && this.selectedReplyToAgentId){
            await this.textTemplateService.getTextTemplateById(this.selectedReplyToAgentId)
            .then(success => {
                if(success.Text) {
                    var text = this.processAutoTextActualValues(success.Text);
                    this.body = this.processEmailBody(text);
                }
            })
        }
        else if(newVal ==  RespondEnum.ToClient && this.selectedForwardToClientId) {
            await this.textTemplateService.getTextTemplateById(this.selectedForwardToClientId)
            .then(success => {
                if(success.Text) {
                    var text = this.processAutoTextActualValues(success.Text);
                    this.body = this.processEmailBody(text);
                }
            })
        }
        else {
            this.body = this.processEmailBody("<p></p>");
        }
    }

    processAutoTextActualValues(text: string) {
        var autoTexts = Object.values(CommentAutoTextEnum);
        var selectedText = text;

        autoTexts.forEach(item => {
            var data : string= "";

            if(item == CommentAutoTextEnum.AgentName) {
                data = this.commentData.AgentName;
            }
            else if(item == CommentAutoTextEnum.ClientName) {
                data = this.commentData.ClientName;
            }
            else if(item == CommentAutoTextEnum.MatterName) {
                data = this.commentData.MatterName;
            }
            else if(item == CommentAutoTextEnum.Country) {
                data = this.commentData.CountryCode;
            }
            else if(item == CommentAutoTextEnum.IssueName) {
                data = this.commentData.IssueName;
            }
            else if(item == CommentAutoTextEnum.CommentDate) {
                data = moment(this.commentData.AgentReponseDate).format("MM-DD-YYYY");
            }
            else if(item == CommentAutoTextEnum.AgentComment) {
                data = this.commentData.AgentComment;
            }

            selectedText = selectedText.split(item).join(data);
        })

        return selectedText;
    }

    processEmailBody(text: string) {
        const Parchment = this.bodyHtmlEditor.get('parchment'); // you can get Quill "Embed" blot by ".get('blots/embed')" 
        const Embed = Parchment.Embed; // base "Embed" blot without any content class 
        class Hr extends Embed {
            static create(value: any) {
                let node = super.create(value);
                node.setAttribute('style', 'display:inline-block; width:98%');

                return node;
            }
        }
        Hr.blotName = 'hr';
        Hr.tagName = 'hr'
        this.bodyHtmlEditor.register(Hr);

        var emailDetails = this.commentEmail;
        var prevFrom = `<strong>From:</strong> ${emailDetails.From}<br/>`;
        var sent = `<strong>Sent:</strong> ${moment(emailDetails.Sent).format("LLLL")}<br/>`;
        var prevTo = `<strong>To:</strong> ${emailDetails.To}<br/>`;
        var subj = `<strong>Subject:</strong> ${emailDetails.Subject}<br/>`;
        var prevCC = emailDetails.Cc ? `<strong>Cc:</strong> ${emailDetails.Cc}<br/>`: '';
        var prevBcc = emailDetails.Bcc ? `<strong>Bcc:</strong> ${emailDetails.Bcc}<br/>`: '';
        var body = emailDetails.Body;

        var result = `${text}
            <br>
            <hr>
            ${prevFrom}${sent}${prevTo}${prevCC}${prevBcc}${subj}
            <br/>
            ${body}
        `

        return result;

    }

    mainEmailSource: string[] = [];
    emailCCSource: string[] = [];
    emailBccSource: string[] = [];
    selectedEmailCC: string[] = [];
    selectedEmailBcc: string[] = [];
    selectedMainEmail: string[] = [];
    selectedToEmail: string[] = [];
    auditorNotes: string = '';
    body:string = '';
    textTemplateService : TextTemplateService;
    duplicateCustomItem: string = '';
    duplicateCustomItemCc: string = '';
    duplicateCustomItemBcc: string = '';
    commentService: CommentService;

    constructor() {
        super();   
        this.textTemplateService = new TextTemplateService();
        this.commentService = new CommentService();
    } 
    validationRule = {
            invalidEmail : {
                type: 'email',
                message : 'Invalid email'
            },
            noError : {}
        }
    onCustomItemCreatingEvent(e:any) {
        if (this.checkEmailValidation(e.text))
        {
            let name = e.component.option("name");
            if(name == "emailCCComponent")
            {
                if(_.find(this.emailCCSource, item => item === e.text)) {
                    this.duplicateCustomItemCc = e.text;
                }
                else {
                    this.emailCCSource.push(e.text);
                }
            }
            else if(name == "emailBccComponent"){
                if(_.find(this.emailBccSource, item => item === e.text)) {
                    this.duplicateCustomItemBcc = e.text;
                }
                else {
                    this.emailBccSource.push(e.text);
                }
            }
            else if(name == "emailToComponent"){
                if(_.find(this.emailToSource, item => item === e.text)) {
                    this.duplicateCustomItem = e.text;
                }
                else {
                    this.emailToSource.push(e.text);
                }
            }
        }
        else {
            e.component.option("isValid", false)
            e.component.option("validationError",this.validationRule.invalidEmail)
        }
    }

    onEmailValueChanged(e:any) {
           
            let val = e.component.option("value");
            let name = e.component.option("name");
            if(name == "emailCCComponent" && this.duplicateCustomItemCc)
            {
                val.push(this.duplicateCustomItemCc);
                e.component.option("value", val);

                this.duplicateCustomItemCc = "";
            }
            else if(name == "emailBccComponent" && this.duplicateCustomItemBcc) {
                val.push(this.duplicateCustomItemBcc);
                e.component.option("value", val);

                this.duplicateCustomItemBcc = "";
            }else if(name == "emailToComponent" && this.duplicateCustomItem) {
                val.push(this.duplicateCustomItem);
                e.component.option("value", val);

                this.duplicateCustomItem = "";
            }
                
            
            if(e.value && e.value.length > 0) {
                if(_.find(e.value,item => !(this.checkEmailValidation(item)))) {
                    e.component.option("isValid", false)
                    e.component.option("validationError",this.validationRule.invalidEmail)
                }
                else {
                    e.component.option("isValid", true)
                    e.component.option("validationError", null)
                }
            }
            else {
                    e.component.option("isValid", true)
                    e.component.option("validationError", null)
        }
    }

    onOpenedEmailAddress(e:any) {
        e.component.content().remove();
    }
    onDiscard(e:any) {
        this.showingNotes = false;
    }

    tagItemStyle(e:any) {
        return {
            'background-color' : this.checkEmailValidation(e) ? '#e0e0e0' : '#f5b5b5'
        }
    }

    checkEmailValidation(text: string) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(text)
    }

    onSendEmail(e: any) {
        let validation = this.validationGroup.validate();
        if(!validation.isValid){
            return;
        }

        if(this.selectedEmailCC && this.selectedEmailCC.length > 0) {
                if(_.find(this.selectedEmailCC, item => !this.checkEmailValidation(item))) {
                    return;
                }
        }
        if(this.selectedEmailBcc && this.selectedEmailBcc.length > 0) {
                if(_.find(this.selectedEmailBcc, item => !this.checkEmailValidation(item))) {
                    return;
                }
        }
        if(this.selectedToEmail && this.selectedToEmail.length > 0) {
                if(_.find(this.selectedToEmail, item => !this.checkEmailValidation(item))) {
                    return;
                }
        }

        var result = confirm(`Are you sure you want to send this email?`, this.title);
        result.then(async dialogResult => {
                    if(dialogResult) {
                        var payload : EmailResponseDto = {
                            Cc : this.selectedEmailCC,
                            Bcc : this.selectedEmailBcc,
                            Subject : this.emailSubject,
                            Body: this.body,
                            To: this.selectedToEmail[0],
                            FileUploadId: this.commentEmail.FileUploadId,
                            ClientName : this.commentData.ClientName,
                            AgentName : this.commentData.AgentName,
                            CommentId: this.commentEmail.CommentId
                        }
                        var res = await this.commentService.sendEmail(payload, this.respondType)
                            .then(success => {
                                return success.Data;
                            })
                            .catch(err => {
                                return false;
                            })
                        if(res) {
                            notify('Email successfully sent.', 'success', 3000);
                            this.showingNotes = false;
                        }
                        else {
                            alert("An error occured while sending the email.", 'Error');
                        }
                    }
                });      
    }

    onPopUpHidden(e: any) {
        this.body = ""
    }

}
